import React from "react"
import "../../styles/CardNuoto.css"
import CardHome from "./CardHome";
import acqua from "../../images/home/copertine2025/NuotoLibero.png";
import palestra from "../../images/home/copertine2025/Palestra.png";
import fitness from "../../images/home/copertine2025/Fitness.png";
import danza from "../../images/home/copertine2025/Danza.png";
import runnering from "../../images/home/copertine2025/Runnering.png";
import spa from "../../images/home/copertine2025/SPA.png";
import NewCard from "./NewCard";


function GroupCard() {
    return(
        <div className="card-container flex-column">
            <div className="d-flex flex-row flex-wrap justify-content-center" >
            <NewCard image={acqua} title={"Piscina"} indirizzo={"/piscina"} coloreSettore="#74B9C7" />
            <NewCard image={palestra} title={"Palestra"} indirizzo={"/palestra"} coloreSettore="#FEC72D" />
            <NewCard image={fitness} title={"Fitness"} indirizzo={"/fitness"} coloreSettore="#FEC72D" />
            </div>
            <div className="d-flex flex-row flex-wrap justify-content-center">
            <NewCard image={danza} title={"Danza"} indirizzo={"/danza"} coloreSettore="#FEC72D" />
            <NewCard image={runnering} title={"Runnering"} indirizzo={"/runnering"} coloreSettore="#FEC72D" />
            <NewCard image={spa} title={"Spa"} indirizzo={"/spa"} coloreSettore="#DFB3B3" />
            </div>
        </div>
    )
}

export default GroupCard